/* eslint-disable react/prop-types */
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

export const PrivateRoute = ({ children }) => {
  const { logueado } = useSelector((state) => state.userAdmin);

  return logueado ? children : <Navigate to="/" />;
};
